@use "../../style/variables" as *;
@use "../../style/mixins" as *;

.login {
  margin-top: 8rem;

  @include mobile {
    margin-top: 0;
  }

  .container {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .wrapper {
    width: 60%;
    margin-left: auto;
    margin-right: auto;

    @include mobile {
      width: 100%;
    }
  }

  .login-container {
    color: $grey-text;
    margin-top: 1.25rem;
    padding-bottom: 2rem;

    .input:nth-child(3) {
      margin-top: 0.625rem;
    }

    @include mobile {
      margin-top: 2rem;
    }
  }

  .text-container {
    text-align: center;
    margin-bottom: 1.5rem;
    line-height: 1.5rem;

    .info-text {
      color: $grey-text;
      font-weight: 300;
    }

    .error-wrapper {
      .error-message {
        margin-top: 0;
      }

      div {
        color: $blue-info;
        font-weight: 300;
        margin-bottom: 1rem;
        margin-top: 1rem;


        .exclamation-point {
          margin-bottom: 0;
        }

        .link {
          text-decoration: underline;
          cursor: pointer;
        }

        .icon {
          &.exclamation svg {
            width: 1.75rem;
            height: 1.75rem;
            vertical-align: center;
          }
        }

        .solid {
          fill: $blue-info;
          stroke: none
        }
      }
    }
  }

  .hide {
    display: none;
  }

  .row {
    display: flex;
    flex-direction: row;
    flex: 1 1 auto;
    justify-content: center;
    margin-top: 5.5rem;
    align-items: baseline;

    @include mobile {
      flex-direction: column;
      align-items: center;
      margin-top: 3.5rem;
    }
  }

  .button-register {
    margin-right: 12px;

    @include mobile {
      margin-right: 0;
      margin-bottom: 1rem;
    }
  }

  .button-login{
    flex-grow: 1;
    margin-left: 12px;

    @include mobile {
      margin-left: 0;
    }
  }

  .password-reset button {
    float: right;
  }

  .save-login-password-reset {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .save-login-password-reset div {
    display: flex;
    align-items: center;
    margin-bottom: 0;
  }

}